import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import SiteNavbar from "./components/navbar/SiteNavbar";
import "./App.css"
import apiConfig from "./auth/AxiosConfig";
import {Helmet, HelmetProvider} from "react-helmet-async";
import FullScreenLoader from "./components/Popup/FullScreenLoader";


function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const checkUserToken = () => {
        const userToken = localStorage.getItem('admin-token');
        if (!userToken || userToken === 'undefined') {
            setIsLoggedIn(false);
        }
        setIsLoggedIn(true);
    }
    useEffect(() => {
        checkUserToken();
    }, [isLoggedIn]);

    useEffect(() => {
        apiConfig(setIsLoading);
    }, []);

    return (
        <React.Fragment>
            <HelmetProvider>
                <Helmet>
                    <meta name="viewport" content="width=1024" />
                </Helmet>
                {isLoading && <FullScreenLoader />}
            {isLoggedIn && <div className={"mb-14"}><SiteNavbar /></div>}
            <Outlet />
            </HelmetProvider>
        </React.Fragment>
    );
}
export default App;
